import { BreadcrumbProps } from '@madeiramadeirabr/breadcrumb-web';

type TGetBreadcrumbItems = {
  crumbItems: BreadcrumbProps['items'];
  previousUrl?: string | null;
  onBackButtonClick?: () => void;
  productId?: number | null;
};

export const getBreadcrumbItems = ({
  crumbItems,
  previousUrl,
  productId,
  onBackButtonClick,
}: TGetBreadcrumbItems) => {
  if (!crumbItems?.length) {
    return [];
  }

  let resultItems = crumbItems;

  if (previousUrl) {
    const backButton = {
      id: 'back-button',
      label: 'Voltar',
      href: previousUrl,
      onClickItem: onBackButtonClick,
    };
    resultItems = [backButton, ...resultItems];
  }

  if (resultItems.length > 0) {
    const lastItem = resultItems[resultItems.length - 1];
    resultItems[resultItems.length - 1] = {
      ...lastItem,
      ...(productId ? { label: `ID: ${productId}` } : {}),
      href: undefined,
    };
  }

  return resultItems;
};
